(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ua-code-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Copy to clipboard. Uses the modern API when allowed, and falls back to a
  // hidden text box for older browsers / in-app browsers.
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '0';
      ta.style.left = '0';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      try { ta.setSelectionRange(0, text.length); } catch (e) {}
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      if (ok) { resolve(); } else { reject(new Error('copy failed')); }
    });
  }

  // One listener for every chip, so it keeps working when the editor re-renders the section.
  document.addEventListener('click', function (e) {
    var chip = e.target && e.target.closest ? e.target.closest('[data-ua-code]') : null;
    if (!chip) return;

    var code = chip.getAttribute('data-ua-code');
    var root = chip.closest('.ua-codes');
    var note = root ? root.querySelector('[data-ua-note]') : null;

    copyText(code).then(function () {
      chip.setAttribute('data-copied', 'true');
      if (note) {
        var tpl = note.getAttribute('data-copied-text') || 'Copied {code}!';
        note.textContent = tpl.replace('{code}', code);
      }
      clearTimeout(chip.__uaChipTimer);
      chip.__uaChipTimer = setTimeout(function () { chip.removeAttribute('data-copied'); }, 1800);
      if (root) {
        clearTimeout(root.__uaNoteTimer);
        root.__uaNoteTimer = setTimeout(function () {
          if (note) note.textContent = note.getAttribute('data-default') || '';
        }, 3500);
      }
    }).catch(function () {
      if (note) note.textContent = 'Could not copy automatically. Press and hold the code to copy it.';
    });
  });

  // On product pages the sticky Add to Cart bar sits at the bottom of the screen;
  // lift the popup above it while it is showing so the two never overlap.
  function setupLift(root) {
    if (root.__uaLift) return;
    root.__uaLift = true;

    function update() {
      var sticky = document.querySelector('.ua-pdp-sticky');
      var lift = 0;
      if (sticky && sticky.classList.contains('is-visible')) lift = sticky.offsetHeight + 10;
      root.style.setProperty('--ua-codes-lift', lift + 'px');
    }

    var stickyEl = document.querySelector('.ua-pdp-sticky');
    if (stickyEl && 'MutationObserver' in window) {
      new MutationObserver(update).observe(stickyEl, { attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('resize', update);
    update();
  }

  function boot() {
    document.querySelectorAll('.ua-codes').forEach(setupLift);
  }

  boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ua-exit-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.ua-exit-popup').forEach(function (popup) {
    var SESSION_KEY = 'uaExitPopupShownThisSession';   // resets every new visit/tab
    var PURCHASED_KEY = 'uaHasPurchased';               // permanent — set once they actually complete an order

    var requireCartItems = popup.getAttribute('data-require-cart-items') === 'true';
    var mobileDelaySeconds = parseInt(popup.getAttribute('data-mobile-delay'), 10) || 0;
    var isReturningCustomer = popup.getAttribute('data-is-returning-customer') === 'true';

    var path = window.location.pathname;
    var onOrderConfirmation = path.indexOf('/thank') !== -1 || path.indexOf('/thank_you') !== -1 || path.indexOf('/orders') === 0;
    var skipPaths = ['/cart', '/checkout'];
    var onSkipPath = skipPaths.some(function (p) { return path.indexOf(p) === 0; }) || onOrderConfirmation;

    // Landing on the real order-confirmation page is the one reliable signal
    // that a purchase actually completed — mark it permanently so the popup
    // never bothers this visitor again, on any future visit.
    if (onOrderConfirmation) {
      try { window.localStorage.setItem(PURCHASED_KEY, 'true'); } catch (e) {}
    }

    var hasPurchased = false;
    try { hasPurchased = window.localStorage.getItem(PURCHASED_KEY) === 'true'; } catch (e) {}

    var shownThisSession = false;
    try { shownThisSession = window.sessionStorage.getItem(SESSION_KEY) === 'true'; } catch (e) {}

    if (onSkipPath || hasPurchased || isReturningCustomer || shownThisSession) return;

    var closeButtons = popup.querySelectorAll('[data-exit-close]');
    var copyBtn = popup.querySelector('[id^="ua-exit-popup-copy-"]');
    var triggered = false;
    var checking = false;

    function showPopup() {
      if (triggered) return;
      triggered = true;
      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');
      try { window.sessionStorage.setItem(SESSION_KEY, 'true'); } catch (e) {}
    }

    function hidePopup() {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
    }

    // Only show if the visitor actually has something sitting in their
    // cart right now — checked live via /cart.js at the moment of the
    // trigger, so it's accurate even if items were added via AJAX earlier
    // in this same page view without a full page reload.
    function maybeShowPopup() {
      if (triggered || checking) return;
      if (!requireCartItems) {
        showPopup();
        return;
      }
      checking = true;
      fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          checking = false;
          if (cart.item_count > 0) showPopup();
        })
        .catch(function () { checking = false; });
    }

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', hidePopup);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hidePopup();
    });

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-code');
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(function () {
            var original = copyBtn.textContent;
            copyBtn.textContent = 'Copied!';
            copyBtn.setAttribute('data-copied', 'true');
            setTimeout(function () {
              copyBtn.textContent = original;
              copyBtn.removeAttribute('data-copied');
            }, 1800);
          }).catch(function () {});
        }
      });
    }

    // Desktop exit-intent: mouse moves up toward the browser chrome (tab bar / close button)
    document.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 0) maybeShowPopup();
    });

    // Mobile / fallback: no reliable mouse-exit signal, so use a time delay instead
    if (mobileDelaySeconds > 0) {
      setTimeout(maybeShowPopup, mobileDelaySeconds * 1000);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ua-live-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.ua-live-banner').forEach(function (banner) {
    if (banner.getAttribute('data-enabled') !== 'true') return;

    // Collect up to two live selling sessions (each has its own start/end).
    var sessions = [];
    [1, 2].forEach(function (n) {
      var startAttr = banner.getAttribute('data-s' + n + '-start');
      var endAttr = banner.getAttribute('data-s' + n + '-end');
      if (!startAttr || !endAttr) return;
      var start = new Date(startAttr);
      var end = new Date(endAttr);
      if (isNaN(start.getTime()) || isNaN(end.getTime())) return;
      sessions.push({
        start: start.getTime(),
        end: end.getTime(),
        label: banner.getAttribute('data-s' + n + '-label') || '',
        key: startAttr + '_' + endAttr
      });
    });
    if (sessions.length === 0) return;
    sessions.sort(function (a, b) { return a.start - b.start; });

    var lastEnd = sessions[sessions.length - 1].end;
    if (Date.now() >= lastEnd) return; // every session is already over

    var showBefore = banner.getAttribute('data-show-before') === 'true';
    var dismissible = banner.getAttribute('data-dismissible') === 'true';
    var DISMISS_KEY = 'uaLiveBannerDismissed_' + sessions.map(function (x) { return x.key; }).join('|');

    try {
      if (window.sessionStorage.getItem(DISMISS_KEY) === 'true') return;
    } catch (e) {}

    var timer = null;
    var labelEl = banner.querySelector('[data-session-label]');
    var closeBtn = banner.querySelector('[data-live-close]');
    if (closeBtn) {
      if (!dismissible) {
        closeBtn.style.display = 'none';
      } else {
        closeBtn.addEventListener('click', function () {
          banner.classList.remove('is-active');
          try { window.sessionStorage.setItem(DISMISS_KEY, 'true'); } catch (e) {}
          if (timer) clearInterval(timer);
        });
      }
    }

    function pad(n) { return String(n).padStart(2, '0'); }

    function setUnits(diff) {
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);
      var map = { days: days, hours: hours, minutes: minutes, seconds: seconds };
      Object.keys(map).forEach(function (key) {
        var el = banner.querySelector('[data-unit="' + key + '"]');
        if (el) el.textContent = pad(map[key]);
      });
    }

    function hideAll() {
      banner.classList.remove('is-active', 'is-live', 'is-upcoming');
    }

    function tick() {
      var now = Date.now();

      // The session that matters right now: the first one that hasn't ended yet.
      // That is either the one currently live, or the next one still to come
      // (so between Day 1 and Day 2 the banner counts down to Day 2).
      var current = null;
      for (var i = 0; i < sessions.length; i++) {
        if (now < sessions[i].end) { current = sessions[i]; break; }
      }
      if (!current) {
        hideAll();
        if (timer) clearInterval(timer);
        return;
      }

      var isLive = now >= current.start;
      if (!isLive && !showBefore) { hideAll(); return; }

      if (labelEl) labelEl.textContent = current.label;
      banner.classList.add('is-active');
      banner.classList.toggle('is-live', isLive);
      banner.classList.toggle('is-upcoming', !isLive);
      setUnits((isLive ? current.end : current.start) - now);
    }

    timer = setInterval(tick, 1000);
    tick();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ua-live-takeover"] && !Shopify.designMode) return;
  try {
    
(function () {
  var BAR_KEY = 'uaOfferBarStart';
  var clockTimer = null;
  var recheckTimer = null;
  var trapKeydown = null;
  var trapFocus = null;
  var visHandler = null;
  var locked = false;

  // Accepts a time like "6:30 PM" / "18:30" (today, Philippine time — so it works
  // every day without editing) or a full date such as 2026-10-30T18:30:00+08:00.
  function parseWhen(str) {
    if (!str) return NaN;
    str = String(str).trim();
    var m = str.match(/^(\d{1,2}):(\d{2})\s*([ap])\.?m?\.?$/i) || str.match(/^(\d{1,2}):(\d{2})()$/) || str.match(/^(\d{1,2})\s*([ap])\.?m\.?$/i);
    if (m) {
      var h = parseInt(m[1], 10);
      var min, ap;
      if (m.length === 3 && isNaN(parseInt(m[2], 10))) { min = 0; ap = m[2]; }
      else { min = parseInt(m[2], 10) || 0; ap = m[3] || ''; }
      ap = (ap || '').toLowerCase();
      if (ap === 'p' && h < 12) h += 12;
      if (ap === 'a' && h === 12) h = 0;
      if (h > 23 || min > 59) return NaN;
      var ph = new Date(Date.now() + 8 * 3600000); // shifted so UTC getters read Philippine wall-clock
      return Date.UTC(ph.getUTCFullYear(), ph.getUTCMonth(), ph.getUTCDate(), h - 8, min, 0);
    }
    return new Date(str).getTime();
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  function lockOff() {
    document.documentElement.classList.remove('ua-takeover-lock');
    if (trapKeydown) { document.removeEventListener('keydown', trapKeydown, true); trapKeydown = null; }
    if (trapFocus) { document.removeEventListener('focusin', trapFocus, true); trapFocus = null; }
    locked = false;
  }

  function stopPolling() {
    if (recheckTimer) { clearInterval(recheckTimer); recheckTimer = null; }
    if (visHandler) { document.removeEventListener('visibilitychange', visHandler); visHandler = null; }
  }

  function unlockAll() {
    lockOff();
    stopPolling();
    if (clockTimer) { clearInterval(clockTimer); clockTimer = null; }
  }

  function release(root) {
    root.classList.add('is-released');
    root.setAttribute('aria-hidden', 'true');
    unlockAll();
  }

  function lockOn(root) {
    if (locked) return;
    locked = true;
    // No scrolling, and keyboard focus can't leave the overlay (it can only move
    // between the overlay's own button, if there is one).
    document.documentElement.classList.add('ua-takeover-lock');
    root.setAttribute('tabindex', '-1');
    try { root.focus({ preventScroll: true }); } catch (e) {}

    trapKeydown = function (e) {
      if (e.key !== 'Tab') return;
      e.preventDefault();
      var list = Array.prototype.slice.call(root.querySelectorAll('a[href], button'));
      if (list.length === 0) { root.focus(); return; }
      var idx = list.indexOf(document.activeElement);
      var next;
      if (e.shiftKey) {
        next = idx <= 0 ? list.length - 1 : idx - 1;
      } else {
        next = (idx === -1 || idx === list.length - 1) ? 0 : idx + 1;
      }
      list[next].focus();
    };
    trapFocus = function (e) {
      if (!root.contains(e.target)) root.focus();
    };
    document.addEventListener('keydown', trapKeydown, true);
    document.addEventListener('focusin', trapFocus, true);

    if (!root.__uaTouchBound) {
      root.__uaTouchBound = true;
      root.addEventListener('touchmove', function (e) { e.preventDefault(); }, { passive: false });
    }
  }

  // Visitors who already have the page open can't close the takeover, so quietly
  // re-check the live page. Once it's switched off in the backend, the page reloads
  // and the site appears.
  function startPolling(seconds) {
    if (recheckTimer || seconds <= 0) return;
    var marker = 'data-ua-' + 'takeover-root';

    function check() {
      fetch(window.location.pathname + window.location.search, { cache: 'no-store', credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) return null;
          return res.text();
        })
        .then(function (html) {
          if (html && html.indexOf(marker) === -1) window.location.reload();
        })
        .catch(function () {});
    }

    recheckTimer = setInterval(check, seconds * 1000);
    visHandler = function () { if (!document.hidden) check(); };
    document.addEventListener('visibilitychange', visHandler);
  }

  function init(root) {
    unlockAll();
    // In the theme editor the takeover shows as a small note, so don't lock anything.
    if (!root || root.classList.contains('is-editor-note')) return;

    var forced = root.getAttribute('data-preview-phase'); // set only in editor preview
    var showFrom = parseWhen(root.getAttribute('data-show-from'));
    var liveStart = parseWhen(root.getAttribute('data-live-start'));
    var endsAt = parseWhen(root.getAttribute('data-ends-at'));
    var seconds = parseInt(root.getAttribute('data-recheck'), 10) || 0;
    var hrs = root.querySelector('[data-tk-unit="hours"]');
    var mins = root.querySelector('[data-tk-unit="minutes"]');
    var secs = root.querySelector('[data-tk-unit="seconds"]');

    function phaseNow() {
      if (forced) return forced; // "live" or "prelive"
      var now = Date.now();
      if (!isNaN(endsAt) && now >= endsAt) return 'ended';
      if (!isNaN(showFrom) && now < showFrom) return 'pending';
      if (!isNaN(liveStart) && now < liveStart) return 'prelive';
      return 'live';
    }

    function setCountdown(diff) {
      if (diff < 0) diff = 0;
      if (hrs) hrs.textContent = pad(Math.floor(diff / 3600000));
      if (mins) mins.textContent = pad(Math.floor((diff / 60000) % 60));
      if (secs) secs.textContent = pad(Math.floor((diff / 1000) % 60));
    }

    function tick() {
      var phase = phaseNow();
      if (phase === 'ended') { release(root); return; }
      if (phase === 'pending') {
        root.classList.add('is-pending');
        lockOff();
        stopPolling();
        return;
      }
      root.classList.remove('is-pending');
      root.classList.toggle('is-prelive', phase === 'prelive');
      lockOn(root);
      if (!forced) startPolling(seconds);
      if (phase === 'prelive') setCountdown(liveStart - Date.now());
    }

    clockTimer = setInterval(tick, 1000);
    tick();
  }

  function takeoverIsShowing() {
    var r = document.querySelector('.ua-takeover');
    return !!(r && !r.classList.contains('is-released') && !r.classList.contains('is-editor-note') && !r.classList.contains('is-pending'));
  }

  // Offers countdown bar. You switch it on and off yourself in the theme editor.
  // While it's on, each visitor gets the countdown from the moment they first see
  // the bar (remembered, so refreshing or changing page doesn't restart it), and
  // the bar disappears for them when it reaches 00:00.
  function initBar(bar) {
    if (bar.__uaBarInit) return;
    bar.__uaBarInit = true;
    if (bar.getAttribute('data-design-mode') === 'true') return; // editor shows a static preview

    var total = (parseInt(bar.getAttribute('data-minutes'), 10) || 5) * 60000;
    var minEl = bar.querySelector('[data-offerbar-min]');
    var secEl = bar.querySelector('[data-offerbar-sec]');
    var start = null;
    var timer = null;

    function getStart() {
      var now = Date.now();
      var s = NaN;
      try { s = parseInt(window.localStorage.getItem(BAR_KEY), 10); } catch (e) {}
      // A start time older than an hour belongs to an earlier round — begin a fresh one.
      if (isNaN(s) || s > now || now - s > 3600000) {
        s = now;
        try { window.localStorage.setItem(BAR_KEY, String(s)); } catch (e) {}
      }
      return s;
    }

    function tick() {
      if (takeoverIsShowing()) { bar.classList.remove('is-active'); return; }
      if (start === null) start = getStart();
      var remaining = start + total - Date.now();
      if (remaining <= 0) {
        bar.classList.remove('is-active');
        if (timer) clearInterval(timer);
        return;
      }
      if (minEl) minEl.textContent = pad(Math.floor(remaining / 60000));
      if (secEl) secEl.textContent = pad(Math.floor((remaining % 60000) / 1000));
      bar.classList.add('is-active');
    }

    timer = setInterval(tick, 1000);
    tick();
  }

  function boot() {
    var root = document.querySelector('.ua-takeover');
    if (root) { init(root); } else { unlockAll(); }
    document.querySelectorAll('[data-ua-offerbar]').forEach(initBar);
  }

  boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function () { setTimeout(boot, 0); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ua-marquee-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.ua-marquee-bar').forEach(function (bar) {
    var track = bar.querySelector('.ua-marquee-track');
    if (!track) return;
    // Slow the animation down proportionally to content width so speed feels
    // consistent regardless of how many messages are configured.
    requestAnimationFrame(function () {
      var setWidth = bar.querySelector('.ua-marquee-set').offsetWidth;
      var pxPerSecond = parseFloat(bar.getAttribute('data-speed')) || 60;
      var duration = setWidth / pxPerSecond;
      track.style.setProperty('--ua-marquee-duration', duration + 's');
      track.style.animationDuration = duration + 's';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ua-product-main"]) return;
  try {
    
(function () {
  // Instead of reinventing the cart bubble ourselves, we lean on Dawn's own
  // rendering: after a successful add, re-fetch the current page (a plain
  // GET, cheap and cache-friendly) and swap in the freshly server-rendered
  // #cart-icon-bubble markup — the exact same accurate HTML Dawn itself
  // would show on a normal page load. No custom bubble, no CSS overrides,
  // no guessing Dawn's internal structure.
  function refreshNativeCartIcon() {
    fetch(window.location.pathname + window.location.search, { cache: 'no-store' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var freshIcon = new DOMParser().parseFromString(html, 'text/html').getElementById('cart-icon-bubble');
        var currentIcon = document.getElementById('cart-icon-bubble');
        if (freshIcon && currentIcon) {
          currentIcon.innerHTML = freshIcon.innerHTML;
        }
      })
      .catch(function () {});
  }

  document.querySelectorAll('product-form-ua').forEach(function (root) {
    var sectionId = root.getAttribute('data-section-id');
    var form = document.getElementById('ua-pdp-form-' + sectionId);
    if (!form) return;

    var variantIdInput = document.getElementById('ua-pdp-variant-id-' + sectionId);
    var qtyInput = document.getElementById('ua-pdp-qty-' + sectionId);
    var addBtn = document.getElementById('ua-pdp-add-btn-' + sectionId);
    var addBtnText = addBtn ? addBtn.querySelector('[data-btn-text]') : null;
    var feedback = document.getElementById('ua-pdp-feedback-' + sectionId);
    var priceWrap = document.getElementById('ua-pdp-price-' + sectionId);
    var stockMsg = document.getElementById('ua-pdp-stock-msg-' + sectionId);
    var mainImage = document.getElementById('ua-pdp-main-image-' + sectionId);

    var variantsScript = document.getElementById('ua-pdp-variants-' + sectionId);
    var variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { variants = []; }

    var pdpRoot = document.getElementById('ua-pdp-' + sectionId);
    var optionGroups = pdpRoot.querySelectorAll('.ua-pdp-option');
    var selected = [];
    optionGroups.forEach(function (group) {
      var current = group.querySelector('.ua-pdp-pill.is-selected');
      selected.push(current ? current.getAttribute('data-option-value') : null);
    });

    function findMatchingVariant() {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return selected.every(function (val, i) { return val === null || opts[i] === val; });
      });
    }

    function formatMoney(cents) {
      return '₱' + (cents / 100).toFixed(2);
    }

    function updateStockMessage(variant) {
      if (!stockMsg) return;
      var threshold = parseInt(stockMsg.getAttribute('data-threshold') || '0', 10);
      if (variant && variant.inventory_management === 'shopify' && typeof variant.inventory_quantity === 'number') {
        if (variant.inventory_quantity > 0 && variant.inventory_quantity <= threshold) {
          stockMsg.textContent = 'Only ' + variant.inventory_quantity + ' left in stock — order soon';
        } else {
          stockMsg.textContent = '';
        }
      } else {
        stockMsg.textContent = '';
      }
    }

    function updateUI() {
      var variant = findMatchingVariant();
      if (!variant) return;

      variantIdInput.value = variant.id;

      if (priceWrap) {
        var html = '<span class="ua-pdp-price__current">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<span class="ua-pdp-price__compare">' + formatMoney(variant.compare_at_price) + '</span>';
        }
        priceWrap.innerHTML = html;
      }

      if (stickyPrice) {
        stickyPrice.textContent = formatMoney(variant.price);
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addBtnText) {
          addBtnText.textContent = variant.available ? 'ADD TO CART' : (addBtn.getAttribute('data-soldout-label') || 'SOLD OUT');
        }
      }

      if (mainImage && variant.featured_image) {
        mainImage.src = variant.featured_image.src.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_1200x1200$1$2');
      }

      updateStockMessage(variant);
    }

    optionGroups.forEach(function (group, index) {
      group.querySelectorAll('.ua-pdp-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.ua-pdp-pill').forEach(function (p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');
          var valueLabel = group.querySelector('[data-selected-value]');
          if (valueLabel) valueLabel.textContent = pill.getAttribute('data-option-value');
          selected[index] = pill.getAttribute('data-option-value');
          updateUI();
        });
      });
    });

    updateStockMessage(findMatchingVariant());

    // Quantity stepper (main form)
    var decreaseBtn = form.querySelector('[data-qty-decrease]');
    var increaseBtn = form.querySelector('[data-qty-increase]');
    var stickyQtyNum = document.getElementById('ua-pdp-sticky-qty-' + sectionId);

    function syncStickyQty() {
      if (stickyQtyNum) stickyQtyNum.textContent = qtyInput.value;
    }

    if (decreaseBtn) decreaseBtn.addEventListener('click', function () {
      var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      qtyInput.value = val;
      syncStickyQty();
    });
    if (increaseBtn) increaseBtn.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      syncStickyQty();
    });

    // Sticky quantity stepper — controls the same qtyInput that actually submits
    var stickyDecreaseBtn = document.querySelector('[data-sticky-qty-decrease]');
    var stickyIncreaseBtn = document.querySelector('[data-sticky-qty-increase]');
    if (stickyDecreaseBtn) stickyDecreaseBtn.addEventListener('click', function () {
      var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      qtyInput.value = val;
      syncStickyQty();
    });
    if (stickyIncreaseBtn) stickyIncreaseBtn.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      syncStickyQty();
    });

    // Sticky bar elements (referenced by the submit handler below)
    var sticky = document.getElementById('ua-pdp-sticky-' + sectionId);
    var stickyBtn = document.getElementById('ua-pdp-sticky-btn-' + sectionId);
    var stickyBtnText = stickyBtn ? stickyBtn.querySelector('[data-sticky-btn-text]') : null;
    var stickyCartCount = document.getElementById('ua-pdp-sticky-cart-count-' + sectionId);
    var stickyPrice = document.getElementById('ua-pdp-sticky-price-' + sectionId);

    function updateStickyCartCount() {
      if (!stickyCartCount) return;
      fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.item_count > 0) {
            stickyCartCount.textContent = cart.item_count > 99 ? '99+' : cart.item_count;
            stickyCartCount.classList.add('is-visible');
          } else {
            stickyCartCount.classList.remove('is-visible');
          }
        })
        .catch(function () {});
    }
    updateStickyCartCount();

    // AJAX add to cart
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn) addBtn.setAttribute('data-state', 'loading');
      if (stickyBtn) stickyBtn.setAttribute('data-state', 'loading');
      if (feedback) feedback.textContent = '';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantIdInput.value, quantity: parseInt(qtyInput.value, 10) || 1 })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          if (addBtn) addBtn.setAttribute('data-state', 'success');
          if (stickyBtn) stickyBtn.setAttribute('data-state', 'success');

          var originalText = addBtnText ? addBtnText.textContent : null;
          if (addBtnText) addBtnText.textContent = 'ADDED';
          var originalStickyText = stickyBtnText ? stickyBtnText.textContent : null;
          if (stickyBtnText) stickyBtnText.textContent = 'ADDED';

          if (feedback) feedback.textContent = 'Added to cart.';
          refreshNativeCartIcon();
          updateStickyCartCount();

          setTimeout(function () {
            if (addBtn) addBtn.removeAttribute('data-state');
            if (addBtnText && originalText) addBtnText.textContent = originalText;
            if (stickyBtn) stickyBtn.removeAttribute('data-state');
            if (stickyBtnText && originalStickyText) stickyBtnText.textContent = originalStickyText;
          }, 1800);
        })
        .catch(function (err) {
          if (addBtn) addBtn.removeAttribute('data-state');
          if (stickyBtn) stickyBtn.removeAttribute('data-state');
          if (feedback) feedback.textContent = (err && err.description) ? err.description : 'Could not add to cart. Please try again.';
        });
    });

    // Sticky CTA — shows once main add-to-cart scrolls out of view
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      observer.observe(addBtn);
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }

    // Gallery thumbnails
    pdpRoot.querySelectorAll('.ua-pdp-gallery__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        pdpRoot.querySelectorAll('.ua-pdp-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImage) mainImage.src = thumb.getAttribute('data-full-src');
      });
    });

    // Share button — native share sheet on mobile, copy-link fallback on desktop
    var shareBtn = document.getElementById('ua-pdp-share-' + sectionId);
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var url = shareBtn.getAttribute('data-url');
        var title = shareBtn.getAttribute('data-title');
        var label = shareBtn.querySelector('[data-share-label]');

        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            if (label) {
              var original = label.textContent;
              label.textContent = 'Link copied';
              setTimeout(function () { label.textContent = original; }, 1800);
            }
          }).catch(function () {});
        }
      });
    }
  });

  // Promo countdown badge (above product title)
  document.querySelectorAll('.ua-pdp-promo').forEach(function (promo) {
    var endDateStr = promo.getAttribute('data-end-date');
    var endDate = endDateStr ? new Date(endDateStr) : null;
    if (!endDate || isNaN(endDate.getTime()) || endDate.getTime() <= Date.now()) {
      promo.style.display = 'none';
      return;
    }

    function updateCountdown() {
      var diff = endDate.getTime() - Date.now();
      if (diff <= 0) {
        promo.style.display = 'none';
        return false;
      }
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);

      var pad = function (n) { return String(n).padStart(2, '0'); };
      var daysEl = promo.querySelector('[data-unit="days"]');
      var hoursEl = promo.querySelector('[data-unit="hours"]');
      var minutesEl = promo.querySelector('[data-unit="minutes"]');
      var secondsEl = promo.querySelector('[data-unit="seconds"]');
      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
      return true;
    }

    if (updateCountdown()) {
      var promoTimer = setInterval(function () {
        if (!updateCountdown()) clearInterval(promoTimer);
      }, 1000);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ua-promo-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.ua-promo-banner').forEach(function (banner) {
    var enabled = banner.getAttribute('data-enabled') === 'true';
    if (!enabled) return;

    var endDateStr = banner.getAttribute('data-end-date');
    var endDate = endDateStr ? new Date(endDateStr) : null;
    if (!endDate || isNaN(endDate.getTime()) || endDate.getTime() <= Date.now()) return; // expired or invalid — stay hidden

    function updateCountdown() {
      var diff = endDate.getTime() - Date.now();
      if (diff <= 0) {
        banner.classList.remove('is-active');
        return false;
      }
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);

      var pad = function (n) { return String(n).padStart(2, '0'); };
      var daysEl = banner.querySelector('[data-unit="days"]');
      var hoursEl = banner.querySelector('[data-unit="hours"]');
      var minutesEl = banner.querySelector('[data-unit="minutes"]');
      var secondsEl = banner.querySelector('[data-unit="seconds"]');
      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
      return true;
    }

    banner.classList.add('is-active');
    if (updateCountdown()) {
      var timer = setInterval(function () {
        if (!updateCountdown()) clearInterval(timer);
      }, 1000);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ua-promo-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.ua-promo-popup').forEach(function (popup) {
    var enabled = popup.getAttribute('data-enabled') === 'true';
    if (!enabled) return;

    var endDateStr = popup.getAttribute('data-end-date');
    var endDate = endDateStr ? new Date(endDateStr) : null;
    if (!endDate || isNaN(endDate.getTime()) || endDate.getTime() <= Date.now()) return; // promo already ended or invalid date — don't show

    var showDelay = parseInt(popup.getAttribute('data-show-delay'), 10) || 3;
    var SESSION_KEY = 'uaPromoPopupShown_' + endDateStr; // resets automatically when the merchant sets a new end date

    var shownThisSession = false;
    try { shownThisSession = window.sessionStorage.getItem(SESSION_KEY) === 'true'; } catch (e) {}
    if (shownThisSession) return;

    var closeButtons = popup.querySelectorAll('[data-promo-close]');
    var countdownEl = popup.querySelector('[id^="ua-promo-countdown-"]');

    function showPopup() {
      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');
      try { window.sessionStorage.setItem(SESSION_KEY, 'true'); } catch (e) {}
    }
    function hidePopup() {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
    }

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', hidePopup);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hidePopup();
    });

    function updateCountdown() {
      var diff = endDate.getTime() - Date.now();
      if (diff <= 0) {
        if (countdownEl) countdownEl.innerHTML = '<span style="font-size:13px;">Offer ended</span>';
        return false;
      }
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);

      var pad = function (n) { return String(n).padStart(2, '0'); };
      var daysEl = popup.querySelector('[data-unit="days"]');
      var hoursEl = popup.querySelector('[data-unit="hours"]');
      var minutesEl = popup.querySelector('[data-unit="minutes"]');
      var secondsEl = popup.querySelector('[data-unit="seconds"]');
      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
      return true;
    }

    if (updateCountdown()) {
      var timer = setInterval(function () {
        if (!updateCountdown()) clearInterval(timer);
      }, 1000);
    }

    setTimeout(showPopup, showDelay * 1000);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
